import { setActiveTab } from '../../../State/activeTab'

export default (value) => (dispatch) => {

  dispatch(setActiveTab(value))

}
